import { createClient as createSupabaseClient } from '@supabase/supabase-js';
let client: ReturnType<typeof createSupabaseClient> | null = null;
export function createClient() {
if (client) return client;
const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
if (!url || !key) {
console.warn('Supabase env vars not set — auth will not work.');
return null as any;
}
client = createSupabaseClient(url, key, {
auth: {
persistSession: true,
autoRefreshToken: true,
detectSessionInUrl: true,
},
});
return client;
}
